module.exports = __webpack_public_path__ + "assets/8e0af5a1f57f1af45d87c3fc216b3235.mp3";